/**
 * Event Producers - All Events Page
 * Event planning and production management
 */

import { useEffect } from 'react';
import { AllProjectsPage } from '@/components/industry/pages/AllProjectsPage';
import { CompanyType } from '@/types/company';
import { MainLayout } from "@/components/MainLayout";

export default function EventsListPage() {
  useEffect(() => {
    document.title = 'Todos os Eventos | Controle Financeiro';
  }, []);

  return (
<MainLayout>
    <div className="container mx-auto py-6">
      <AllProjectsPage
        domain={CompanyType.EVENT_PRODUCERS}
        title="Todos os Eventos"
        description="Gerencie seus eventos e produções"
        createButtonLabel="Novo Evento"
      />
    </div>
  
    </MainLayout>);
}

